module.exports = __webpack_public_path__ + "img/pacote-auditoria-estrategia.e4474191.jpg";